import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateCompanyUser($companyId: ID!, $id: ID!, $attributes: CompanyUserAttributes!) {
    updateCompanyUser(companyId: $companyId, id: $id, attributes: $attributes) {
      companyUser {
        id
        ...UpdatedCompanyUser
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedCompanyUser on CompanyUser {
    id
    role
  }
`
